import React from "react";
import { Modal } from "react-responsive-modal";
import UserProfile from "views/UserProfile/UserProfile";
import Scrollbar from "react-scrollbars-custom";
import "assets/scss/partials/microsoftTeams.scss";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";

export default ({ openUserDialog, closeDialog }) => {
  return (
    <Modal
      showCloseIcon={false}
      open={openUserDialog}
      closeOnOverlayClick={false}
      onClose={closeDialog}
      center={true}
      classNames={{ modal: "microsoftTeamUserProfileModal" }}
      closeOnEsc={false}
    >
      <div className="microsoftTeamsDialogHeader">
        {" "}
        User Profile
        <div className="closeMicrosoftTeamsDialog">
          <CloseIcon onClick={closeDialog} className="cursor" />
        </div>
      </div>
      <div style={{ padding: "0px 8px 0px 14px" }}>
        <Scrollbar style={{ height: "calc(100vh - 60px)" }}>
          <UserProfile />
        </Scrollbar>
      </div>
    </Modal>
  );
};
